import { Binding, BindingShape } from "../../../../../types";
import { SpaceDefinition } from "../../../types";
import { ComponentNode } from "../../RenderTreeContext";
import { getColumnsSchema } from "../common/ColumnListManager/getColumnsOutputShape";

export function getSchema(
  node: ComponentNode,
  spaces: Map<string, SpaceDefinition>
): Binding[] {
  return [
    {
      name: "cards",
      shape: BindingShape.OBJECT_ARRAY,
      attributes: getColumnsSchema(node, spaces)
    }
  ];
}
